<template>
  <div class="xmodal-animate" v-auto-animate="$animate">
    <div
      class="xmodal-wrapper"
      v-if="modalActive"
      @click.self="handleClickOutside"
    >
      <div class="xmodal-inner" :data-fullscreen="modalState.fullscreen">
        <div class="xmodal">
          <div class="xmodal-close" @click="closeModal"></div>
          <h2 v-if="modalState.title" class="xmodal-title">
            {{ modalState.title }}
          </h2>
          <p v-if="modalState.description" class="xmodal-description">
            {{ modalState.description }}
          </p>
          <div
            v-if="modalState.html"
            v-html="modalState.html"
            class="xmodal-html"
          ></div>
          <div v-if="hasButtons" class="xmodal-buttons">
            <button
              v-for="(button, index) in modalState.buttons"
              :key="index"
              @click="button.onClick()"
            >
              {{ button.title }}
            </button>
          </div>
          <div v-else-if="hasLoading" class="xmodal-buttons">
            <opal-button :text="modalState.title" :loading="true" />
          </div>
          <div v-else class="xmodal-buttons">
            <button @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import store from "@/store";
import OpalButton from "@/components/shared/OpalButton.vue";
import { RootStore } from "@/types/root-store";

const modalState = computed(() => (store.state as RootStore).modal);

const modalActive = computed<boolean>(
  () => (store.state as RootStore).modal.active
);

const hasButtons = computed<boolean>(
  () => modalState.value.buttons?.length > 0 && !modalState.value.loading
);

const hasLoading = computed<boolean>(
  () => modalState.value.buttons?.length > 0 && modalState.value.loading
);

function handleClickOutside(): void {
  if (modalState.value.allowClickOutsideToClose) {
    closeModal();
  }
}

const closeModal = (): void => {
  (store.state as RootStore).modal.active = false;
};
</script>

<style scoped></style>
